import { css, useTheme } from "@emotion/react";
import PropTypes from "prop-types";
import { em } from "@util/convertUnits";
import CmsImageLoader from "../../../base/CmsImageLoader";


const FlexImagesWidget = ({ content }) => {
    const theme = useTheme();
    const imageLength = content.images.length;

    const subheaderCss = css(`
        text-align:center;
        min-width:15em;
    `);

    const handleImageCss = css(`
        margin:10px 1em;
        flex-basis: calc(100%/6);
        display:flex;
        margin-bottom:2em;
        align-items: center;
        justify-content: center;
        min-width:8em;
        min-height:8em;
        padding-left:1em;
        flex-direction:column;
        max-height: ${imageLength > 1 ? "22em" : "12em"};
        @media (min-width: ${em(theme.breakpoint.ns, 16)}) {
            
            padding: 0;
            flex-direction: column;
            align-items: center;
            justify-content: center;

            img{
                margin-bottom: 10px;
            }
        }
   
    `)

    const largeImageCss = (`
        min-width:300px;
        min-height:300px;
        max-height: 300px;
        max-width: 300px;
    `)

    const hardwareOptionText = css(`
        font-size: 12px;
        width: 12em;
        height: 2em;
        text-align:center;
        margin-bottom: 2em;
    `);

    const imageWrapperCss = css(`
        display:flex;
        width: 100vw;
        flex-wrap: wrap;
        justify-content: center;
    `);


    const { label, images } = content;
    const imagesDom = images.map(i => {
        return <div css={[handleImageCss, content.largeImages && largeImageCss]} key={`${i.swatch_url}_${i.swatch_label}`}>
            <CmsImageLoader
                url={i.swatch_url}
                alt={i.swatch_label}
                style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "contain"
                }}
            />
            <div css={hardwareOptionText}>{i.swatch_label ? i.swatch_label : ""}</div>
        </div>
    })

    return <div>
        {label ? <h4 css={subheaderCss}> {label}</h4> : null}
        <div css={imageWrapperCss}>{imagesDom}</div>
    </div>;
};

FlexImagesWidget.propTypes = {
    content: PropTypes.object,
};

export default FlexImagesWidget;
